import FormControl from "@mui/material/FormControl";
import Input, { InputProps } from "@mui/material/Input";
import FormFieldError from "components-redesign/FormFieldError";
import FormFieldHelperText from "components-redesign/FormFieldHelperText";
import FormFieldWarning from "components-redesign/FormFieldWarning";
import InputLabel from "components-redesign/InputLabel";
import { FIGMA_COLORS, commonClasses } from "components-redesign/styles";

const outlinedSx = {
  borderRadius: "8px",
  border: "1px solid #E5E1E1",
  background: "#FFF",
  padding: "12px",
  "&:before": {
    display: "none",
  },
  "&:after": {
    display: "none",
  },
  "&.Mui-error:before": {
    borderBottomColor: FIGMA_COLORS.errorLight,
  },
};

type Props = {
  inputProps: InputProps;
  name?: string;
  error?: string | boolean;
  helperText?: string;
  warning?: string;
  noUnderline?: boolean;
  label?: string;
  multiline?: boolean;
  rows?: number;
  endAdornment?: React.ReactNode;
  variant?: "underline" | "outlined";
} & Omit<
  InputProps,
  "name" | "error" | "helperText" | "warning" | "inputProps"
>;

const TextInput = ({
  name,
  error,
  helperText,
  warning,
  inputProps,
  noUnderline,
  variant = "underline",
  ...props
}: Props) => {
  const handleWheel = (event) => {
    if (inputProps.type === "number") {
      event.target.blur();
    }
  };

  const underlineSx = {
    "&:after": {
      borderBottom: noUnderline
        ? "none"
        : commonClasses.inputUnderline.borderBottom,
      borderBottomStyle: "solid",
    },
    "&.MuiInput-root.Mui-disabled:before": {
      borderBottom: noUnderline
        ? "none"
        : commonClasses.inputUnderline.borderBottom,
    },
    "&.Mui-error:before": {
      borderBottomColor: FIGMA_COLORS.errorLight,
    },
  };

  return (
    <FormControl
      fullWidth={props.fullWidth}
      disabled={props.disabled}
      sx={{
        "& .MuiInputBase-root": {
          marginTop: "0px",
        },
      }}>
      {props.label ? (
        <InputLabel error={!!error}>{props.label}</InputLabel>
      ) : null}
      <Input
        multiline={props.multiline}
        rows={props.rows}
        type="text"
        error={!!error}
        endAdornment={props.endAdornment}
        onWheel={handleWheel}
        sx={{
          ...commonClasses.inputValue,
          ...(variant === "outlined" ? outlinedSx : underlineSx),
        }}
        {...inputProps}
      />
      {error && <FormFieldError id={name} text={error} />}
      {warning && <FormFieldWarning id={name} text={warning} />}
      {helperText && <FormFieldHelperText id={name} text={helperText} />}
    </FormControl>
  );
};

export default TextInput;
